import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { ITrialClaimRequest, ITrialClaimTransactionResponse } from '@interfaces';
import { Observable } from 'rxjs';
import { APIConstants } from '@services';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class TrialClaimsService {
  constructor(
    private readonly http: HttpClient
  ) {}

  public runTrialClaim(request: ITrialClaimRequest): Observable<ITrialClaimTransactionResponse> {
    const url = `${environment.apiGatewayBaseURL}${APIConstants.DRUG_PRICING_TEST_CLAIM_SUBMIT}?subscription-key=${environment.scApiSubscriptionKey}`;
    return this.http.post<ITrialClaimTransactionResponse>(url, request).pipe(take(1));
  }
}
